function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 24H20V47H24.5V24Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 24H1V47H5.5V24Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15 56H11V87H15V56Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15 18H11V49H15V18Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1 53V47L5.59574 47.5C11.4613 50.1752 14.7104 50.3954 20.4043 47.5L24.5 47V53C15.9873 56.3288 11.2146 56.2707 1 53Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.3974 44C78.1912 55.7544 65.9642 55.7886 43.7007 44C40.169 61.6313 40.0312 71.701 43.7007 90.0364C66.0215 94.0462 78.1997 93.9291 99.3974 90.0364C103.006 71.9364 102.727 61.8647 99.3974 44Z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 23,
  r: 22.5
});

var SvgFarmer = function SvgFarmer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 94,
    viewBox: "0 0 103 94",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFarmer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Farmer.9f9927bd.svg";
export { ForwardRef as ReactComponent };